import { not, rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const partShowRules = composition => {
  const { check, variantIs, planIsAtLeast, stateIsMaximized, aspectTypeIs, isTuvVerified, platformIs } = composition.checkers;

  return [
    rule('part/tuvSeal/show')
      .when(planIsAtLeast('start').and(isTuvVerified).and(not(stateIsMaximized.and(variantIs('mid')))).and(not(variantIs('footer'))))
      .set(() => ({
        parts: {
          tuvSeal: {
            show: true
          }
        }
      })),

    rule('mobile/island/expanded/part/tuvSeal/show')
      .when(platformIs('mobile').and(variantIs('island').and(aspectTypeIs('expanded'))))
      .set(() => ({
        parts: {
          tuvSeal: {
            show: false,
          }
        }
      })),

    rule('part/container/show')
      .when(aspectTypeIs('expanded').or(check(() => !composition.constraints.hideContainerWhenMinimized)))
      .set(() => ({
        container: {
          show: true
        }
      })),

    rule('part/maximizeArrow/show')
      .when(aspectTypeIs('collapsed'))
      .set(() => ({
        parts: {
          maximizeArrow: {
            show: true
          }
        }
      })),

    rule('part/contents/show')
      .when(aspectTypeIs('expanded').and(check(() => composition.parts.contents.present)))
      .set(() => ({
        parts: {
          contents: {
            show: true
          }
        }
      })),

    rule('part/headerTexts/show')
      .when(aspectTypeIs('expanded').or(planIsAtLeast('start').and(variantIs('mid').or(variantIs('island')))))
      .set(() => ({
        parts: {
          headerText: {
            show: true
          }
        }
      })),
  ];
};
